/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Hero_Fact_1Inputs */

const en_mk_hero_fact_1 = /** @type {(inputs: Mk_Hero_Fact_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connected plans & tasks`)
};

const id_mk_hero_fact_1 = /** @type {(inputs: Mk_Hero_Fact_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rencana & tugas terhubung`)
};

/**
* | output |
* | --- |
* | "Connected plans & tasks" |
*
* @param {Mk_Hero_Fact_1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_hero_fact_1 = /** @type {((inputs?: Mk_Hero_Fact_1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Hero_Fact_1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_hero_fact_1(inputs)
	return en_mk_hero_fact_1(inputs)
});